<script type="text/javascript">
	import { onMount, createEventDispatcher } from "svelte"
	import ModalWindow from "../ModalWindow.svelte"
	import Button, {Label} from '@smui/button';

	const dispatch = createEventDispatcher(); // confirm | cancel

	let instance;
	export let open = false;

	let onConfirm = () => {
		dispatch("confirm");
	}
	let onCancel = () => {
		dispatch("cancel");
	}

	let style = "width:100%;margin-top:10px;";

</script>

<ModalWindow
	materialIcon={"warning"}
	title={`Are you sure?`}
	hasCloseButton={false}
	hasBackground={true}
	resizable={false}
	draggable={false}
	fullscreen={false}
	padding={true}
	layer={3}
	bind:open={open}
	bind:this={instance}
	>
	<p>Are you sure you want to do this? It cannot be undone.</p>

	<Button color="secondary" variant="unelevated" class="bg-error" on:click={onConfirm} style={style}><Label>Yes</Label></Button>
	<Button color="primary" variant="unelevated"  class="bg-info" on:click={onCancel} style={style}><Label>No</Label></Button>

</ModalWindow>
